import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  rootGrid: {
    height: '600px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
  },
  paddingGrids: {
    margin: '28px',
    width: '95%',
    height: '450px',
  },
  styleButtons: {
    marginRight: '10px',
  },
  contentInfoAuto: {
    marginBottom: '4rem',
    borderRadius: '15px',
    border: '.2px solid #e2e0e0',
  },
}))

export default useStyles
